"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDOMImage = void 0;
/**
 * Can be used to load images in browser-based applications.
 */
function loadDOMImage(url, crossOrigin) {
    if (crossOrigin === void 0) { crossOrigin = null; }
    var image = new Image();
    image.crossOrigin = crossOrigin;
    image.src = url;
    return new Promise(function (resolve, reject) {
        image.onload = function () { return resolve(image); };
        image.onerror = function (e) { return reject(new Error("Failed to load image: " + url)); }; // `e` contains no useful info
    });
}
exports.loadDOMImage = loadDOMImage;
//# sourceMappingURL=loadDOMImage.js.map